import { WindowState } from '../state';
import { RoedenMode, RoedenPattern, RoedenConfig } from '../types';

const MODE_OPTIONS: { value: RoedenMode; label: string }[] = [
  { value: 'none', label: 'None' },
  { value: 'true-divided', label: 'True Divided Light' },
  { value: 'applied', label: 'Applied Bars' },
  { value: 'between-glass', label: 'Between Glass' },
];

const PATTERN_OPTIONS: { value: RoedenPattern; label: string }[] = [
  { value: 'none', label: 'None' },
  { value: '1x2', label: '1x2' },
  { value: '2x1', label: '2x1' },
  { value: '2x2', label: '2x2 (Cross)' },
  { value: '3x1', label: '3x1' },
  { value: '1x3', label: '1x3' },
  { value: '3x2', label: '3x2' },
  { value: '2x3', label: '2x3' },
  { value: 'perimeter', label: 'Perimeter (Staal-look)' },
];

export function createRoedenSelector(state: WindowState): HTMLElement {
  const container = document.createElement('div');

  // Apply to all sections
  const firstSection = state.config.sections[0];
  const currentRoeden = firstSection?.roeden ?? { mode: 'none' as RoedenMode, pattern: 'none' as RoedenPattern };

  // Mode
  const modeRow = document.createElement('div');
  modeRow.className = 'opt-row';

  const modeLabel = document.createElement('span');
  modeLabel.className = 'opt-label';
  modeLabel.textContent = 'Mode';

  const modeSelect = document.createElement('select');
  modeSelect.className = 'opt-select';

  for (const opt of MODE_OPTIONS) {
    const option = document.createElement('option');
    option.value = opt.value;
    option.textContent = opt.label;
    if (currentRoeden.mode === opt.value) option.selected = true;
    modeSelect.appendChild(option);
  }

  modeRow.appendChild(modeLabel);
  modeRow.appendChild(modeSelect);
  container.appendChild(modeRow);

  // Pattern
  const patternRow = document.createElement('div');
  patternRow.className = 'opt-row';

  const patternLabel = document.createElement('span');
  patternLabel.className = 'opt-label';
  patternLabel.textContent = 'Pattern';

  const patternSelect = document.createElement('select');
  patternSelect.className = 'opt-select';

  for (const opt of PATTERN_OPTIONS) {
    const option = document.createElement('option');
    option.value = opt.value;
    option.textContent = opt.label;
    if (currentRoeden.pattern === opt.value) option.selected = true;
    patternSelect.appendChild(option);
  }

  patternRow.appendChild(patternLabel);
  patternRow.appendChild(patternSelect);
  container.appendChild(patternRow);

  // On change, apply to all sections
  const applyRoeden = () => {
    const roeden: RoedenConfig = {
      mode: modeSelect.value as RoedenMode,
      pattern: patternSelect.value as RoedenPattern,
    };
    for (let i = 0; i < state.config.sections.length; i++) {
      state.setSectionRoeden(i, roeden);
    }
  };

  modeSelect.addEventListener('change', applyRoeden);
  patternSelect.addEventListener('change', applyRoeden);

  return container;
}
